// src/components/ProductCard.jsx
import React, { useState } from 'react';
import { FaShoppingCart } from 'react-icons/fa';
import ComingSoonModal from './ComingSoonModal/ComingSoonModal';
import './ProductCard.css';

export default function ProductCard({ product, onAddToCart, onPreorder }) {
  const [showComingSoon, setShowComingSoon] = useState(false);

  // Fix: Get the correct image URL
  const getImageUrl = () => {
    // Check different possible image locations
    if (product.images?.full) return product.images.full;
    if (product.images?.modal) return product.images.modal;
    if (product.image && typeof product.image === 'string') return product.image;
    
    // Fallback
    return '/images/placeholder.jpg';
  };

  // Check for preorder availability
  const isPreorderAvailable = product.preorderAvailable === true || 
                              product.preorder === true || 
                              product.isPreorder === true;

  // Get preorder progress
  const preorderProgress = product.preorderGoal && product.preorderGoal > 0
    ? Math.min(((product.preorders || 0) / product.preorderGoal) * 100, 100)
    : 0;

  return (
    <div className="product-card">
      <div className="image-wrapper">
        <img
          src={getImageUrl()}
          alt={product.name}
          loading="lazy"
          onError={(e) => {
            e.target.src = '/images/placeholder.jpg';
          }}
        />
        
        {/* Cart Icon Button */}
        <button
          className="cart-icon-button"
          onClick={() => onAddToCart && onAddToCart(product)}
          aria-label={`Add ${product.name} to cart`}
        >
          <FaShoppingCart size={20} />
        </button>
      </div>

      <h3 className="product-name">{product.name}</h3>
      <p className="product-price">${(product.price / 100).toFixed(2)}</p>

      {/* Preorder Progress Bar (if preorder is available) */}
      {isPreorderAvailable && product.preorderGoal && (
        <div className="preorder-progress">
          <div className="progress-bar">
            <div 
              className="progress-fill" 
              style={{ width: `${preorderProgress}%` }}
            />
          </div>
          <span className="progress-text">
            {product.preorders || 0} / {product.preorderGoal} preordered
          </span>
        </div>
      )}

      {/* Single Button - Preorder or Add to Cart */}
      <div className="product-buttons">
        {isPreorderAvailable ? (
          <button
            className="preorder-btn"
            onClick={() => onPreorder && onPreorder(product)}
          >
            🎯 Preorder Now
          </button>
        ) : (
          <button
            className="add-to-cart-btn"
            onClick={() => onAddToCart && onAddToCart(product)}
          >
            🛒 Add to Cart
          </button>
        )}
      </div>

      {/* Coming Soon Modal */}
      {showComingSoon && (
        <ComingSoonModal
          product={product}
          onClose={() => setShowComingSoon(false)}
        />
      )}
    </div>
  );
}